export const APPLICATION_VERSION = '2.21.0'; export const APPLICATION_ENV = 'production';
